module.exports = __webpack_public_path__ + "f340d9d2431ba447cf6dbae540683c23.png";